import React from 'react'
import { Col, Row } from 'react-bootstrap'

const Footer = () => {
  return (
    <div className='footer container pt-3'>
      <Row xs={1} md={2} lg={2}>
      <Col>
        <div className='text p-2'>
        <p>
          <img src='/images/logo.png' alt='...' className='img img-fluid '/>
        </p>
        </div>
      </Col>
        <Col> 
          <div>
            <ul className='d-flex justify-content-between align-items-center fw-bold '>
              <li>Home</li>
              <li>About Us</li>
              <li>Blog</li>
              <li>Contacts</li>
              <li>Terms</li>
            </ul>
            <p className='text-end'> &copy; IT LOGISTS</p>
          </div>
      </Col>
      </Row>
    </div>
  )
}

export default Footer